import { ref } from 'vue'
import { useDisasterStore } from '@/stores/disasterStore'
import { useLoadingView } from '@/features/miiaFw/composables/useLoadingView'
import { useOverheadImageStore } from '@/stores/overheadImageUrlsStore'

/** 表示フラグ（true: 表示, false: 非表示） */
const isOpen = ref<boolean>(false)

export const useOverheadImage = () => {
  const disasterStore = useDisasterStore()
  const overheadImageStore = useOverheadImageStore()
  const { setLoadingView } = useLoadingView()

  /**
   * 開く
   * @param flightId フライトID
   * @returns なし
   */
  const open = async (flightId: string): Promise<void> => {
    try {
      // フライトIDから家屋画像URLsを取得
      await overheadImageStore.fetch({
        govCode: disasterStore.disaster!.govCode,
        disasterId: disasterStore.disaster!.disasterId,
        flightId: flightId
      })
    } finally {
      setLoadingView(false)
    }
    // コンポーネントを表示
    isOpen.value = true
  }

  /**
   * 閉じる
   * @param なし
   * @return なし
   */
  const close = (): void => {
    isOpen.value = false
  }

  /**
   * 変数群のリセット
   * @param なし
   * @returns なし
   */
  const reset = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    open,
    close,
    reset
  }
}
